import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Product } from '@app/core/interfaces';
import { TabStates } from '../product-detail/product-detail';
import { BaseComponent } from '@app/core/bases';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { PhotoService, ProductService } from '@app/core/services';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TabsModule } from "primeng/tabs";
import { ProductDetailDistributionEbay } from "../product-detail-distribution-ebay/product-detail-distribution-ebay";
import { ProductDetailDistributionWebshop } from "../product-detail-distribution-webshop/product-detail-distribution-webshop";
import {TooltipModule} from "primeng/tooltip";
import {takeUntil} from "rxjs";

@Component({
  selector: 'app-product-detail-distribution',
  imports: [CommonModule, TooltipModule, FormsModule, TagModule, ButtonModule, ConfirmDialogModule, ProgressSpinnerModule, TabsModule, ProductDetailDistributionEbay, ProductDetailDistributionWebshop],
  providers: [ConfirmationService, DialogService],
  templateUrl: './product-detail-distribution.html'
})
export class ProductDetailDistribution extends BaseComponent implements OnInit, OnChanges {
  @Input() product!: Product;
  @Output() productChange: EventEmitter<Product> = new EventEmitter<Product>();

  @Input() tabStates!: TabStates[];
  @Output() tabStatesChange: EventEmitter<TabStates[]> = new EventEmitter<TabStates[]>();

  @Input() tabIndex!: number;

  activeTab: number = 0;
  subTabStates: TabStates[] = []
  stockTabIndex: number = 0;

  isLoadingData: boolean = true;
  isSendingData: boolean = false;
  isRefreshingData: boolean = false;

  constructor(
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private productService: ProductService,
    private photoService: PhotoService
  ) {
    super();
  }

  ngOnInit() {
    this.initTabs();
  }

  initTabs() {
    this.subTabStates = [
      { index: 0, active: this.activeTab === 0, loaded: false },
      { index: 1, active: this.activeTab === 1, loaded: false },
    ];
    this.tabStates.map((state: TabStates) => {
      if (state.index === this.tabIndex)
        state.loaded = true
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabStates']) {
      const tab: TabStates = this.tabStates.find(state => state.index === this.tabIndex) as TabStates
      if (tab.active && !tab.loaded) {
        this.initTabs();
      }
    }
  }

  onTabChange(newIndex: string | number | undefined) {
    this.subTabStates.map((state) => state.active = state.index === newIndex);
    this.subTabStates = [...this.subTabStates]
  }

  onNeedStockTabReload() {
    const tab: TabStates = this.tabStates.find(state => state.index === this.stockTabIndex) as TabStates
    if (tab.loaded) {
      tab.loaded = false;
      this.tabStatesChange.emit(this.tabStates);
    }
  }

    refreshEbayStocks() {
        this.isRefreshingData = true;
        this.apiCall$?.unsubscribe();
        this.apiCall$ = this.apiCall$ = this.productService.postGenererEbay(this.product.id, { update_only: 1 })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                complete: () => {
                    this.isRefreshingData = false;
                    this.initTabs();
                }
            });
    }
}
